// ---------------------------------------------------------------------------
// locale.context.ts — React Context for SSR-safe locale propagation
// ---------------------------------------------------------------------------
// Eliminates the English flash on locale-prefixed routes by providing the
// locale through React Context (which works on both server and client),
// instead of relying solely on the Zustand store (which defaults to 'en'
// during SSR because there is no window/localStorage).
//
// Priority: LocaleContext > Zustand store > 'en' default
// ---------------------------------------------------------------------------

'use client';

import { createContext, useContext } from 'react';
import type { SupportedLocale } from './i18n.config';

/**
 * Context for locale-prefixed routes. Null when no locale prefix is present
 * (e.g. direct /integrations/stripe without /ar/ prefix).
 */
export const LocaleContext = createContext<SupportedLocale | null>(null);

/**
 * Read locale from context. Returns null when outside a locale provider.
 */
export function useLocaleContext(): SupportedLocale | null {
  return useContext(LocaleContext);
}
